import { connect } from 'react-redux'
import BoletoForm from './BoletoForm'
import { documentSelector } from 'auth/selectors'

const mapStateToProps = state => {
    const { type: documentType, number: documentNumber } = documentSelector(state)

    return {
        defaultFormData: {
            documentType,
            documentNumber,
        },
    }
}

export default connect(mapStateToProps)(BoletoForm)
